import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Home.css';

// just text line

const Home = () => {
    // 1. Создаем реф для второй секции
    const brandsSectionRef = useRef(null);

    // 2. Функция для плавного скролла
    const scrollToBrands = () => {
        if (brandsSectionRef.current) {
            brandsSectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // Свойства карточек брендов
    const brands = [
        {
            id: 1,
            // name: 'ROLLS-ROYCE',
            // logo: '/assets/ROLLS - ROYS SERVICE PARTNER WHITE.png',
            bgDesktop: '/assets/vertical/RolsRoys_vertical.jpg',
            bgMobile: '/assets/horizontal/RolsRoys_landscape.jpg',
            links: [
                { title: 'Сервис', url: '#' },
                { title: 'Цены', url: '#' },
            ]
        },
        {
            id: 2, 
            name: 'BMW',
            logo: '/assets/bmw_logo.png',
            bgDesktop: '/assets/vertical/BMW_X5_VERTIKAL.jpg', 
            bgMobile: '/assets/horizontal/BMW_X5_horizontal.jpg',
            links: [
                { title: 'Автомобили в наличии', url: '/catalog/new' },
                { title: 'Автомобили с пробегом', url: '/catalog/used' },
                { title: 'Тест - драйв', url: '/test-drive-appointment' },
                { title: 'BMW Сервис', url: '/service-appointment' },
            ]
        },
        {
            id: 3, 
            name: 'BMW MOTORRAD',
            logo: '/assets/BMW MOTORRAD LOGO WHITE.png',
            bgDesktop: '/assets/vertical/BMW_MOTORRAD_VERTIKAL.jpg', 
            bgMobile: '/assets/horizontal/BMW_MOTORRAD_HORIZONTAL.jpg',
            links: [
                { title: 'Модели', url: 'https://bmw-motorrad.uz/moto_models' },
                { title: 'Тест - драйв', url: 'https://bmw-motorrad.uz/test-drive' },
                { title: 'MOTORRAD Сервис', url: 'https://bmw-motorrad.uz/service-request'},
            ]
        },
        {
            id: 4, 
            name: 'NISSAN',
            logo: '/assets/NISSAN LOGO WORD WHITE.png',
            bgDesktop: '/assets/vertical/NISSAN_PATROL_VERTIKAL.jpg',
            bgMobile: '/assets/horizontal/NISSAN_PATROL_HORIZONTAL.jpg',
            links: [
                { title: 'Автомобили в наличии', url: '#' },
                { title: 'Тест - драйв', url: '#' },
                { title: 'NISSAN Сервис', url: '#' },
            ]
        },
    ];

    // Массив для благотворительных программ
    const charityProjects = [
        {
            id: 1,
            title: '105 000 саксаулов для Арала: Premium Auto и BMW поддержали восстановление экосистемы',
            description: 'Компания Premium Auto, при поддержке глобального автомобильного бренда BMW, реализовала значимый экологический проект в Узбекистане, направленный на восстановление природного баланса в регионе Приаралья.',
            image: '/assets/charity_programms/102.png',
        },
        {
            id: 2,
            title: 'Проект был реализован в два этапа.',
            description: 'В период осень–зима 2025 года была проведена подготовительная часть — высадка семян саксаула, предназначенных для дальнейшей посадки на территории высохшего дна Аральского моря.',
            image: '/assets/charity_programms/116.png', 
        },
        {
            id: 3,
            title: 'Данная инициатива является частью программы устойчивого развития и отражает стремление Premium Auto и BMW',
            description: 'Проект в Приаралье стал примером того, как совместные усилия бизнеса, государственных экологических структур и международных партнёров могут вносить реальный вклад в восстановление природных ресурсов и борьбу с опустыниванием.',
            image: '/assets/charity_programms/117.jpg', 
        }
    ];

    const partners = [
        { name: 'Befit', logo: 'assets/partners_logo/befit.png' },
        { name: 'Kaptial Bank', logo: 'assets/partners_logo/KB_LOGO.svg' },
        // { name: 'Nissan', logo: 'assets/partners_logo/nissan.png' },
        // { name: 'BMW', logo: 'assets/partners_logo/bmw.png' },
    ];
    return (
        <div className="page-wrapper">

            <div>
                <Helmet>
                    <title>PREMIUM AUTO</title>
                </Helmet>
            </div>

            {/* Первая секция: Видео */}
            <div className="heroSection">
                <video autoPlay muted loop playsInline className="hero-video">
                    <source src="/assets/bg_video.mp4" type="video/mp4" />
                </video>
            </div>

            {/* Вторая секция: Карточки брендов */}
            <div ref={brandsSectionRef} className="brands-section">
                {brands.map((brand) => (
                    <div key={brand.id} className="brand-card">
                        <div className="brand-card-inner">
                            {/* Фоновая картинка с CSS-переменными */}
                            <div
                                className={`brand-bg brand-bg-${brand.id}`}
                                style={{ 
                                    '--bg-desktop': `url(${brand.bgDesktop})`,
                                    '--bg-mobile': `url(${brand.bgMobile})`
                                }}
                            />
                            
                            {/* Контент поверх карточки */}
                            <div className="brand-overlay">
                                {/* Логотип сверху */}
                                <div className="brand-logo-container">
                                    <img src={brand.logo} alt={brand.name} className="brand-logo-img" />
                                </div>
                                
                                {/* Текстовые ссылки снизу */}
                                <div className="brand-footer">
                                    {brand.links && (
                                        <div className="brand-links-list">
                                            {brand.links.map((link, index) => (
                                                <Link 
                                                    key={index} 
                                                    to={link.url} 
                                                    className="brand-action-link"
                                                >
                                                    {link.title}
                                                </Link>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Раздел OUR VISION */}
            <section className="vision-section">
                <h2 className="section-title">НАШЕ ВИДЕНИЕ</h2>
                <p className="vision-text">
                    Компания с более чем 20-летним опытом в сфере премиальной автомобильной индустрии, объединяющая международные стандарты, глубокую экспертизу и безупречный клиентский сервис.
                </p>
                <div className="stats-container">
                    <div className="stat-item">
                        <span className="stat-value">2000 +</span>
                        <span className="stat-label">ЛОЯЛЬНЫЕ КЛИЕНТЫ</span>
                    </div>
                </div>
            </section>

            {/* Раздел Charity programs */}
            <section className="charity-section" id="Our_charaty_program">
                <h2 className="section-title main-charity-title">УСТОЙЧИВОЕ РАЗВИТИЕ</h2>
                
                <div className="charity-projects-list">
                    {charityProjects.map((project, index) => (
                        <div 
                            key={project.id} 
                            className={`charity-item ${index % 2 !== 0 ? 'reverse' : ''}`}
                        >
                            <div className="charity-image-wrapper">
                                <img src={project.image} alt={project.title} className="charity-image" />
                            </div>
                            <div className="charity-content">
                                <h3 className="charity-title">{project.title}</h3>
                                {project.description && (
                                    <p className="charity-description">{project.description}</p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
{/* 
                <div className="charity-footer-action">
                    <Link to="#" className="charity-btn">
                        Подробнее
                    </Link>
                </div> */}
            </section>

            {/* Раздел OUR PARTNERS */}
            <section className="partners-section">
                <h2 className="section-title">НАШИ ПАРТНЁРЫ</h2>
                <div className="partners-grid">
                    {partners.map((partner, index) => (
                        <div key={index} className="partner-logo-box">
                            <img src={partner.logo} alt={partner.name} className="partner-logo" />
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Home;